import * as React from 'react';
import { InstagramEmbed } from 'react-social-media-embed';
import { SocialEmbedContainer } from '../socialEmbedContainer';
export var Instagram = function (props) {
    var link = props.link;
    return (React.createElement(SocialEmbedContainer, null,
        React.createElement(InstagramEmbed, { url: link, width: "100%" })));
};
